import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { AbstractService } from '@shared/abstract.service';
import { HttpClient } from '@angular/common/http';
import { SERVICES, HTTP_METHODS } from '@root/constant';
import { VideoData } from '@catalog/catalogue-videos/catalogue-video.model';
import { ArticleData } from '@catalog/catalogue-articles/catalogue-article.model';
import { EncryptionProviderService } from '@shared/encryption.service';
import { JobData } from './catalouge-careers/catalouge-careers.model';

const URL = `${SERVICES.CATALOG.PATH}/adminportal`;

@Injectable()
export class CatalogService extends AbstractService<any> {
  textSubSections:any[]=[]
  constructor(
    http: HttpClient,
    encryptionProviderService: EncryptionProviderService
  ) {
    super(http, URL, encryptionProviderService);
    this.encryptionProviderService = encryptionProviderService;
  }

  // -------------------------BANNERS
  public readAllImageCategories(data: any): Observable<any> {
    return this.request({
      method: HTTP_METHODS.POST,
      url: `${this.url}/getImageCategories`,
      body: data,
    });
  }

  public uploadBanner(data: any): Observable<any> {
    return this.request({
      method: HTTP_METHODS.POST,
      url: `${this.url}/uploadBanner`,
      body: data,
    });
  }

  public readAllBanner(data: any): Observable<any> {
    return this.request({
      method: HTTP_METHODS.POST,
      url: `${this.url}/getBanners`,
      body: data,
    });
  }

  public uploadFundManagerBanner(data: any): Observable<any> {
    return this.request({
      method: HTTP_METHODS.POST,
      url: `${this.url}/uploadFundMangerImage`,
      body: data,
    });
  }

  public uploadKeyFeatureImage(data: any): Observable<any> {
    return this.request({
      method: HTTP_METHODS.POST,
      url: `${this.url}/uploadKeyFeatureImage`,
      body: data,
    });
  }

  public uploadInvestmentApproachImage(data: any): Observable<any> {
    return this.request({
      method: HTTP_METHODS.POST,
      url: `${this.url}/uploadInvestmentApproachImage`,
      body: data,
    });
  }

  public readAllFundManagerBanner(): Observable<any> {
    return this.request({
      method: HTTP_METHODS.GET,
      url: `${this.url}/getFundMangerImages`,
    });
  }

  readAllSchemes(): Observable<any> {
    return this.request({
      method: HTTP_METHODS.GET,
      url: `${this.url}/getSchemes`,
    });
  }

  readAllFundmangers(): Observable<any> {
    return this.request({
      method: HTTP_METHODS.GET,
      url: `${this.url}/getFundManagers`,
    });
  }

  readAllKeyFeature(): Observable<any> {
    return this.request({
      method: HTTP_METHODS.GET,
      url: `${this.url}/getKeyHeadings`,
    });
  }

  readAllInvestmentApproach(): Observable<any> {
    return this.request({
      method: HTTP_METHODS.GET,
      url: `${this.url}/getInvestmentApproachHeadings`,
    });
  }
  // -------------------------EXCEL

  public getExcelCategories(data : any): Observable<any> {
    return this.request({
      method: HTTP_METHODS.POST,
      url: `${this.url}/getCategories`,
      body: data,
    });
  }

  public uploadExcelData(data: FormData, section: string): Observable<any> {
    return this.request({
      method: HTTP_METHODS.POST,
      url: this.getUploadExcelUrl(section),
      body: data,
    });
  }

  private getUploadExcelUrl(section: string): string {
    let url = `${this.url}`;
    switch (section) {
      case 'Product Details':
        url = `${url}/uploadProductDetails`;
        break;
      case 'Product Returns':
        url = `${url}/uploadProductReturns`;
        break;
      case 'Product Key Features':
        url = `${url}/uploadKeyfeatures`;
        break;
      case 'Product Asset Allocation':
        url = `${url}/uploadAssetallocation`;
        break;
      case 'Product Stocks':
        url = `${url}/uploadStocks`;
        break;
      case 'Product Sector':
        url = `${url}/uploadSector`;
        break;
      case 'education-video':
        url = `${url}/uploadInvestorVideo`;
        break;
      case 'AMC Branches':
        url = `${url}/uploadAMC`;
        break;
      case 'Kfintech Branches':
        url = `${url}/uploadKfin`;
        break;
      case 'Locate Your Advisor':
        url = `${url}/uploadLocateAdvisor`;
        break;
      case 'Point Of Acceptance':
        url = `${url}/uploadPointOfAcceptance`;
        break;
      case 'Product Fund Manager':
        url = `${url}/uploadFundManager`;
        break;
      case 'Product SIP Returns':
        url = `${url}/uploadProductSIPReturns`
        break;
      case 'Product Lumpsum Returns':
        url = `${url}/uploadProductLumpsumReturns`
        break;
      case 'Relationship Manager':
        url = `${url}/uploadRelationshipManager`
        break;
      case 'Investment Approach':
      url = `${url}/uploadInvestmentApproach`
    }
    return url;
  }

  public readExcelContentHistory(data: any): Observable<any> {
    return this.request({
      method: HTTP_METHODS.POST,
      url: `${this.url}/getContentHistory`,
      body: data,
    });
  }

  // -------------------------VIDEO
  public uploadVideoData(data: VideoData, section: string): Observable<any> {
    return this.request({
      method: HTTP_METHODS.POST,
      url: this.getUploadVideoUrl(section, data),
      body: data,
    });
  }

  private getUploadVideoUrl(section: string, data: VideoData): string {
    let url = `${this.url}`;
    switch (section) {
      case 'PRODUCT_VIDEO':
        url = data.id ? `${url}/editVideo` : `${url}/uploadVideo`;
        break;
      case 'INVESTOR_VIDEO':
        url = data.id
          ? `${url}/editInvestorVideo`
          : `${url}/uploadInvestorVideo`;
        break;
    }

    return url;
  }

  public readProductVideos(): Observable<any> {
    return this.request({
      method: HTTP_METHODS.GET,
      url: `${this.url}/getVideos`,
    });
  }

  public readInvestorVideos(): Observable<any> {
    return this.request({
      method: HTTP_METHODS.GET,
      url: `${this.url}/getInvestorVideos`,
    });
  }

  // ------------------------- PDF
  public readPDFTypes(data: any): Observable<any> {
    return this.request({
      method: HTTP_METHODS.POST,
      url: `${this.url}/getTypes`,
      body: data,
    });
  }

  public readPDFSections(data: any): Observable<any> {
    return this.request({
      method: HTTP_METHODS.POST,
      url: `${this.url}/getSectionsByType`,
      body: data,
    });
  }

  public readPDFSubSections(data: any): Observable<any> {
    return this.request({
      method: HTTP_METHODS.POST,
      url: `${this.url}/getSubSectionsByType`,
      body: data,
    });
  }

  public uplaodPDFData(type: number, data: FormData) {
    return this.request({
      method: HTTP_METHODS.POST,
      url: this.getUploadPDFUrl(type),
      body: data,
    });
  }

  public readPDFData(type: number) {
    return this.request({
      method: HTTP_METHODS.GET,
      url: this.readPDFDataUrl(type),
    });
  }
  private getUploadPDFUrl(type: number): string {
    let url = `${this.url}`;
    switch (type) {
      case 1:
      case 2:
      case 5:
      case 7:
      case 8:
      case 9:
        url = `${url}/uploadMFDocuments`;
        break;
      case 3:
      case 4:
      case 6:
        url = `${url}/uploadPartnerDocuments`;
        break;
    }
    return url;
  }

  private readPDFDataUrl(type: number): string {
    let url = `${this.url}`;
    switch (type) {
      case 1:
      case 2:
      case 5:
      case 7:
      case 8:
      case 9:
        url = `${url}/getmfdocs`;
        break;
      case 3:
      case 4:
      case 6:
        url = `${url}/getpartnerdocs`;
        break;
    }
    return url;
  }

  public getYear(data: any): Observable<any> {
    let url = `${SERVICES.CATALOG_STATUTORY.PATH}/getYear`
    return this.request({
      method: HTTP_METHODS.POST,
      url: url,
      body: data,
    });
  }

  public getMonth(): Observable<any> {
    let url = `${SERVICES.CATALOG_STATUTORY.PATH}/getMonth`
    return this.request({
      method: HTTP_METHODS.GET,
      url: url,
    });
  }

  // ------------------------- Articles
  public addOrUpdateArticle(data: ArticleData | FormData): Observable<any> {
    return this.request({
      method: HTTP_METHODS.POST,
      url: this.uploadArticle(data),
      body: data,
    });
  }

  private uploadArticle(data: ArticleData | FormData): string {
    let url = `${this.url}`;
    const isFormData = data instanceof FormData;
    const isUpdate = data instanceof FormData ? !!data.get('id') : !!data['id'];

    url = isUpdate
      ? `${url}/updateArticle`
      : isFormData
      ? `${url}/uploadArticleImage`
      : `${url}/addArticles`;
    return url;
  }

  public addMedia(type: string, data: FormData): Observable<any> {
    return this.request({
      method: HTTP_METHODS.POST,
      url: `${this.url}/uploadArticleImage`,
      body: data,
    });
  }

  public readArticles(data: any): Observable<any> {
    return this.request({
      method: HTTP_METHODS.POST,
      url: `${this.url}/getAdminArticles`,
      body: data,
    });
  }

  public updateArticle(data: any): Observable<any> {
    return this.request({
      method: HTTP_METHODS.POST,
      url: `${this.url}/updateArticle`,
      body: data,
    });
  }

  public deleteArticle(data: any): Observable<any> {
    return this.request({
      method: HTTP_METHODS.POST,
      url: `${this.url}/deleteArticle`,
      body: data,
    });
  }

  public featureArticle(data: any): Observable<any> {
    return this.request({
      method: HTTP_METHODS.POST,
      url: `${this.url}/featurearticle`,
      body: data,
    });
  }

  public uploadThumbnail(data: any): Observable<any> {
    return this.request({
      method: HTTP_METHODS.POST,
      url: `${this.url}/uploadThumbnail`,
      body: data,
    });
  }

  // ------------------------- Careers
  public getCareersDeparment(): Observable<any> {
    const url = SERVICES.CATALOG.PATH;
    return this.request({
      method: HTTP_METHODS.GET,
      url: `${url}/getDepartment`,
    });
  }

  public getCareersLocation(): Observable<any> {
    const url = SERVICES.CATALOG.PATH;
    return this.request({
      method: HTTP_METHODS.GET,
      url: `${url}/getLocation`,
    });
  }

  public addOrUpdateCareer(data: JobData): Observable<any> {
    return this.request({
      method: HTTP_METHODS.POST,
      url: this.getActionUrl(data),
      body: data,
    });
  }

  public getActionUrl(data: JobData): string {
    let url = `${this.url}`;
    url = data.id ? `${url}/updateCareerJob` : `${url}/addCareerJob`;
    return url;
  }

  public getCareerJobs(data: any): Observable<any> {
    return this.request({
      method: HTTP_METHODS.POST,
      url: `${this.url}/getCareerJobs`,
      body: data,
    });
  }

  public deleteCareerJob(data: any): Observable<any> {
    return this.request({
      method: HTTP_METHODS.POST,
      url: `${this.url}/deleteCareerJob`,
      body: data,
    });
  }

  // ------------------------- Nav & Dividends
  public uploadNavDividendExcel(data: FormData, type: string): Observable<any> {
    return this.request({
      method: HTTP_METHODS.POST,
      url: this.uploadExcelUrl(type),
      body: data,
    });
  }

  public updateNavExcel(data: FormData): Observable<any> {
    let url = `${this.url}`;
    return this.request({
      method: HTTP_METHODS.POST,
      url: `${url}/editNav`,
      body: data,
    });
  }

  private uploadExcelUrl(type: string): string {
    let url = `${this.url}`;
    switch (type) {
      case 'NAV':
        url = `${url}/uploadNav`;
        break;
      case 'Dividend':
        url = `${url}/uploadDividend`;
        break;
    }
    return url;
  }

  // ------------------------- Config

  public addCareerLocation(data: any): Observable<any> {
    return this.request({
      method: HTTP_METHODS.POST,
      url: `${this.url}/addCareerLocation`,
      body: data,
    });
  }

  public addCareerDepartment(data: any): Observable<any> {
    return this.request({
      method: HTTP_METHODS.POST,
      url: `${this.url}/addCareerDepartment`,
      body: data,
    });
  }

  public updateCareerLocation(data: any): Observable<any> {
    return this.request({
      method: HTTP_METHODS.POST,
      url: `${this.url}/updateCareerLocation`,
      body: data,
    });
  }

  public updateCareerDepartment(data: any): Observable<any> {
    return this.request({
      method: HTTP_METHODS.POST,
      url: `${this.url}/updateCareerDepartment`,
      body: data,
    });
  }

  public deleteCareerLocation(data: any): Observable<any> {
    return this.request({
      method: HTTP_METHODS.POST,
      url: `${this.url}/deleteCareerLocation`,
      body: data,
    });
  }

  public deleteCareerDepartment(data: any): Observable<any> {
    return this.request({
      method: HTTP_METHODS.POST,
      url: `${this.url}/deleteCareerDepartment`,
      body: data,
    });
  }

// ------------Access Rights to tabs for user

  public readUserAccessRightstoTabs(data: any): Observable<any> {
    let url = `${SERVICES.USER_MANAGMENT.PATH}/user/tabs`
    return this.request({
      method: HTTP_METHODS.POST,
      url: url,
      body: data,
    });
  }

  // ------------Add Digit Factsheet API
  public addDigitalFactsheet(data: any): Observable<any> {
    return this.request({
      method: HTTP_METHODS.POST,
      url: `${this.url}/digitalfactsheet/add`,
      body: data,
    });
  }

  // ------------Read Digit Factsheet API
  public readDigitalFactsheet(data: any): Observable<any> {
    return this.request({
      method: HTTP_METHODS.POST,
      url: `${this.url}/digitalfactsheet`,
      body: data,
    });
  }

  public deleteDigitalFactsheet(data: any): Observable<any> {
    return this.request({
      method: HTTP_METHODS.POST,
      url: `${this.url}/digitalfactsheet/delete`,
      body: data,
    });
  }
  
  // about us 
public getTeamList(): Observable<any> {
  return this.request({
    method: HTTP_METHODS.GET,
    url: `${this.url}/aboutus/sections`,
   
  });
}

public getTeamMembersList(): Observable<any> {
  return this.request({
    method: HTTP_METHODS.GET,
    url: `${this.url}/aboutus/getAll`,
   
  });
}

public addTeamMember(data:FormData): Observable<any> {
  return this.request({
    method: HTTP_METHODS.POST,
    url: `${this.url}/aboutus/add`,
    body: data,
  });
}

public updateTeamMember(data:FormData): Observable<any> {
  return this.request({
    method: HTTP_METHODS.POST,
    url: `${this.url}/aboutus/update`,
    body: data,
  });
}

public deleteTeamMember(data: any): Observable<any> {
  return this.request({
    method: HTTP_METHODS.DELETE,
    url: `${this.url}/aboutus/delete`,
    body: data,
  });
}
// IAP Page related API calls
//banners
public getSectionList(): Observable<any> {
  return this.request({
    method: HTTP_METHODS.GET,
    url: `${this.url}/iapPage/sections`,
   
  });
}

public addBanner(data:FormData): Observable<any> {
  return this.request({
    method: HTTP_METHODS.POST,
    url: `${this.url}/uploadOrEditIapPageBanner`,
    body: data,
  });
}

public getBanners(): Observable<any> {
  return this.request({
    method: HTTP_METHODS.GET,
    url: `${this.url}/getIapPageBanners`,
   
  });
}

public deleteBanner(data: any): Observable<any> {
  return this.request({
    method: HTTP_METHODS.DELETE,
    url: `${this.url}/deleteIapPageBanner`,
    body: data,
  });
}
public updateBanner(data:FormData): Observable<any> {
  return this.request({
    method: HTTP_METHODS.POST,
    url: `${this.url}/uploadOrEditIapPageBanner`,
    body: data,
  });
}

//Videos
public addOrUpdateVideo(data:any): Observable<any> {
  return this.request({
    method: HTTP_METHODS.POST,
    url: `${this.url}/uploadOrEditIapPageVideo`,
    body: data,
  });
}

public getVideos(): Observable<any> {
  return this.request({
    method: HTTP_METHODS.GET,
    url: `${this.url}/getIapPageVideos`,
   
  });
}

public deleteVideo(data: any): Observable<any> {
  return this.request({
    method: HTTP_METHODS.DELETE,
    url: `${this.url}/deleteIapPageVideo`,
    body: data,
  });
}

public addOrUpdateInfographic(data:any): Observable<any> {
  return this.request({
    method: HTTP_METHODS.POST,
    url: `${this.url}/uploadOrEditIapPageInfographic`,
    body: data,
  });
}


public getInfographics(): Observable<any> {
  return this.request({
    method: HTTP_METHODS.GET,
    url: `${this.url}/getIapPageInfographics`,
   
  });
}

public deleteInfographic(data: any): Observable<any> {
  return this.request({
    method: HTTP_METHODS.DELETE,
    url: `${this.url}/deleteIapPageInfographic`,
    body: data,
  });
}

public addOrUpateArticle(data:any): Observable<any> {
  return this.request({
    method: HTTP_METHODS.POST,
    url: `${this.url}/uploadOrEditIapPageBlog`,
    body: data,
  });
}


public getArticles(): Observable<any> {
  return this.request({
    method: HTTP_METHODS.GET,
    url: `${this.url}/getIapPageBlogs`,
   
  });
}

public deleteBlog(data: any): Observable<any> {
  return this.request({
    method: HTTP_METHODS.DELETE,
    url: `${this.url}/deleteIapPageBlog`,
    body: data,
  });
}
  public updateDividendExcel(data: FormData): Observable<any> {
    let url = `${this.url}`;
    return this.request({
      method: HTTP_METHODS.POST,
      url: `${url}/editDividend`,
      body: data,
    });
  }
//Text Section related APIs

  public getIapPageTextSections(): Observable<any> {
    return this.request({
      method: HTTP_METHODS.GET,
      url: `${this.url}/getIapPageTextSections`,

    });
  }

  public addOrEditIapPageText(data: any): Observable<any> {
    return this.request({
      method: HTTP_METHODS.POST,
      url: `${this.url}/addOrEditIapPageText`,
      body: data,
    });
  }

  public getIapPageTextBySection(data): Observable<any> {
    return this.request({
      method: HTTP_METHODS.GET,
      url: `${this.url}/getIapPageTextBySection?sectionId=${data}`,

    });
  }

  setTextSubSections(data) {
    this.textSubSections = data
  }
 
  getIdBySectionName(sectionName: string) {
    let sectionId = undefined;
    const matchedSection = this.textSubSections.find(
      (section) => section.sectionName === sectionName
    );
    if (matchedSection) {
      sectionId = matchedSection.id;
    }
    return sectionId
  }


  public deleteText(data: any): Observable<any> {
    return this.request({
      method: HTTP_METHODS.DELETE,
      url: `${this.url}/deleteIapPageText`,
      body: data,
    });
  }
}

